/* jshint -W024 */
// singleItem script extends category script
import "./base";

// =========================
// Common
// =========================
import "./app/eros/common/mobileStickyButtons";

// =========================
// External Plugins
// =========================
import "./app/eros/plugins/external/svbadge";
import "./app/eros/plugins/external/magiczoomplus";

// =========================
// COMPONENTS
// =========================
import SingleItem from "./app/eros/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);
import SingleItemSetComponent from "./app/ceres/components/item/SingleItemSetComponent.vue";
Vue.component("single-item-set-component", SingleItemSetComponent);
import TabList from "./app/eros/components/common/TabList.vue";
Vue.component("tab-list", TabList);
import TabItem from "./app/ceres/components/common/TabItem.vue";
Vue.component("tab-item", TabItem);

import ItemImageCarousel from "./app/eros/components/item/ItemImageCarousel.vue";
import AddToBasket from "./app/eros/components/basket/AddToBasket.vue";
Vue.component("add-to-basket", AddToBasket);
Vue.component("item-image-carousel", ItemImageCarousel);
import SingleAddToBasket from "./app/eros/components/item/SingleAddToBasket.vue";
Vue.component("single-add-to-basket", SingleAddToBasket);

import TimeLeftToOrder from "./app/eros/components/item/TimeLeftToOrder.vue";
Vue.component("time-left-to-order", TimeLeftToOrder);
import DynamicItemListItem from "./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItem.vue";
Vue.component("dynamic-item-list-item", DynamicItemListItem);

Vue.component("add-item-to-basket-overlay", () => import("./app/ceres/components/basket/AddItemToBasketOverlay.vue"));

Vue.component("add-article-notification", () => import("./app/eros/components/item/AddArticleNotification.vue"));
Vue.component("dynamic-item-list-item-tag", () =>
	import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemTag.vue")
);

Vue.component("dynamic-item-list-item-attr-cross", () =>
	import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemAttrCross.vue")
);
Vue.component("dynamic-item-list-item-variation-session", () =>
	import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemVariationSession.vue")
);

Vue.component("FeedbackAverage", () => import("./app/eros/plugins/plentymarkets/feedback/components/item/FeedbackAverage.vue"));
Vue.component("FeedbackContainer", () => import("./app/eros/plugins/plentymarkets/feedback/components/item/singleitem/FeedbackContainer.vue"));